export default __webpack_public_path__ + "cb71deafc73cd423a33aab1b98f8e2f4.webp";